import { useTranslation } from 'react-i18next'

import { ProgressSpinner } from 'primereact/progressspinner'

export const FullscreenLoadingOverlay: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen min-w-full flex justify-content-center align-items-center">
      <div className="flex flex-column align-items-center">
        <ProgressSpinner
          style={{ width: '48px', height: '48px' }}
          strokeWidth="2"
        />
        <span className="mt-3 text-sm">{t('common.labels.loading')}</span>
      </div>
    </div>
  )
}
